import { RoutesT } from '@/routes/Routes.types';
import { LazyNotFoundPage } from '@/pages';

export const serviceRoutes: RoutesT = {
    notFound: {
        path: '/404',
        label: 'Страница не найдена',
        element: <LazyNotFoundPage />,
        title: 'Страница не найдена',
        description: 'К сожалению, такой страницы нет.',
        hideHeader: true,
    },
};
